import {InputContextValue} from 'components/common/CartItemBuilder/providers/InputProvider/types'
import {useCallback} from 'react'
import {useUserInputStepManager} from './useUserInputStepManager'

export const useAvailabilityManager = (cartItemInputContextValue: InputContextValue) => {
  const getSavedData = useCallback(() => {
    return cartItemInputContextValue.input.availabilityId
  }, [cartItemInputContextValue])

  const setSavedData = useCallback(
    (availabilityId: string) => {
      return cartItemInputContextValue.mutators.setAvailabilityId(availabilityId)
    },
    [cartItemInputContextValue]
  )

  const isDataTouched = useCallback((availabilityId: string) => {
    return Boolean(availabilityId)
  }, [])

  const isDataValid = useCallback((availabilityId: string) => {
    return Boolean(availabilityId)
  }, [])

  return useUserInputStepManager<string>({
    getSavedData,
    setSavedData,
    isDataTouched,
    isDataValid,
    hint: 'Please select a start time',
  })
}
